<template>
  <div class="app-container">
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="5">
          <!--  车牌号   -->
          <el-form-item :label="$t('GlobalSetObj.licensePlateNumber')">
            <el-select
              v-model="printObj.vehicleNumber"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="getVehicleNumber"
              clearable
              filterable
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @focus="getVehicleNumber(printObj.vehicleNumber)"
            >
              <el-option
                v-for="(item, index) in vehicleNumberList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="19">
          <el-form-item style="margin-top: 28px">
            <!-- 打印 -->
            <el-button
              size="small" type="primary" @click="clickPrint"
            >{{ $t('scripting.printReturnCode') }}
            </el-button>
            <!-- 导出PDF -->
            <el-button
              size="small" @click="generateReturnCode"
            >{{ $t('scripting.generateReturnCode') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :cell-style="{ 'text-align': 'center' }"
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black', 'text-align': 'center' }"
      border
      style="width: 100%"
    >
      <el-table-column :label="$t('GlobalSetObj.serial')" type="index" width="80" />
      <el-table-column :label="$t('GlobalSetObj.LoadCarTime')" min-width="180" prop="loadTime" />
      <el-table-column
        :label="$t('GlobalSetObj.licensePlateNumber')"
        min-width="180"
        prop="vehicleNumber"
      />
      <el-table-column
        :label="$t('scripting.nextStationHub')"
        min-width="180"
        prop="nextSiteIdName"
      />
      <el-table-column :label="$t('scripting.returnCode')" min-width="150" prop="returnCode" />
      <el-table-column :label="$t('scripting.expiryTime')" min-width="150" prop="abortTime" />
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.number"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!--打印大包号-->
    <div class="printStyle">
      <returnCodeHtml
        v-if="showPrintReturnCodeHtml"
        :param-data="paramDataList"
        @hiddenBagNumberHtml="hiddenBagNumberHtml"
      />
    </div>
    <addReturnCode ref="addReturnCodeRef" :next-site-list="nextSiteList" @search="childrenSearch" />
  </div>
</template>

<script>
import returnCodeHtml from './component/returnCodeHtml.vue';
import addReturnCode from './component/addReturnCode.vue';
import { printReturnCode, returnCodePage } from '@/api/storeAdmin';
import { getAllsite } from '@/api/logisticsOrders';
import { vehicleTagNumber } from '@/api/orderApi';

export default {
  name: 'LoadingDocument',
  components: {
    returnCodeHtml,
    addReturnCode
  },
  data() {
    return {
      // 是否格式化成巴西时间
      showPrintReturnCodeHtml: false,
      paramDataList: [],
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        number: 1,
        total: 0
      },
      printObj: {
        nextSiteId: '',
        vehicleNumber: null
      },
      vehicleNumberList: [], // 车签号
      tableData: [],
      nextSiteList: []
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getVehicleNumber('');
    this.getSearch();
    this.getNextSite();
  },
  methods: {
    // 获取下一站网点
    getNextSite() {
      getAllsite().then((res) => {
        if (res.code === 200) {
          this.nextSiteList = res.data;
        }
      });
    },
    // 清空打印袋号数据
    hiddenBagNumberHtml() {
      this.showPrintReturnCodeHtml = false;
      this.resetForm();
      this.enterSearch();
    },
    enterSearch() {
      this.queryForm.number = 1;
      this.getSearch();
    },
    childrenSearch() {
      this.enterSearch();
    },
    generateReturnCode() {
      this.$refs.addReturnCodeRef.showAddDialog();
    },
    // 点击打印
    clickPrint() {
      if (!this.printObj.vehicleNumber) {
        this.$message.error(this.$t('GlobalSetObj.pleaseSelectLicenseNumber'));
        return;
      }
      const data = {
        vehicleNumber: this.printObj.vehicleNumber
      };
      printReturnCode(data).then((res) => {
        if (res.code === 200) {
          this.paramDataList = res.data;
          if (this.paramDataList.length === 0) {
            this.$message.error(this.$t('scripting.noAvailableReturnCode'));
            return;
          }
          this.showPrintReturnCodeHtml = true;
        }
      });
    },
    // 重置
    resetForm() {
      this.paramDataList = [];
      this.printObj = {
        printCount: 1,
        vehicleNumber: null
      };
    },
    // 查询
    getSearch() {
      const data = {
        params: {
          vehicleNumber: '',
          nextSiteId: ''
        }
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.number;
      returnCodePage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.number = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.number = val;
      this.getSearch();
    },
    // 车牌号
    getVehicleNumber(val) {
      console.log(val, 'getVehicleNumber0111');
      const data = {
        number: val,
        queryType: 1
      };
      vehicleTagNumber(data).then((res) => {
        if (res.code === 200) {
          this.vehicleNumberList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.printStyle {
  display: none;
}
</style>
